import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const guestReviewNotificationMessages = {
  [AutomationEventTypes.ReviewHostSubmitted]: {
    subject: 'Review Submitted for Your Stay at *|RENTAL:NAME|*!',
    message: `
      Dear *|GUEST:NAME|*,

      I hope you're doing well! I wanted to let you know that a review has been submitted for your recent stay at *|RENTAL:NAME|*. It was a pleasure hosting you, and I truly appreciated how respectful and considerate you were during your visit.

      If you’d like to read the review, it should be available soon on the platform where you made your reservation. I hope your experience was memorable, and I would be delighted to host you again in the future.

      If you have any feedback or questions, please don't hesitate to reach out. Wishing you all the best in your future travels!
      `,
  },
  [AutomationEventTypes.ReviewPending]: {
    subject: 'We’d Love to Hear About Your Stay at *|RENTAL:NAME|*!',
    message: `
      Dear *|GUEST:NAME|*,

      We hope you had a wonderful stay at *|RENTAL:NAME|*! It was a pleasure hosting you, and we hope you made some great memories during your time here.
      If you have a few moments, we would be so grateful if you could leave a review of your experience. Your feedback helps us improve and assists future guests in making their decisions. We truly value your thoughts!
      You can leave a review here:
      *|CHANNEL:REVIEW_LINK|*
      We truly appreciate your time and effort in sharing your experience with us. Should you ever plan to visit again, we would be delighted to host you!
      Thank you once again, and we hope to welcome you back soon.
    `,
  },
}

export const userReviewNotificationMessages = {
  [AutomationEventTypes.ReviewGuestSubmitted]: {
    subject: 'Reminder: Don’t Forget to Share Your Review for Guest',
    message: `
      Hi Team,

      Your guest has just submitted their review for their stay at *|RENTAL:NAME|*
      To keep your profile strong and maintain great guest relationships, don’t forget to add your review in return. Reviews build trust and boost your visibility on booking platforms.
      Property Name: *|RENTAL:NAME|*
      Guest Name: *|GUEST:NAME|*

      Thank you for being an amazing host!
    `,
  },
}
